import React from "react"
import Layout from "../components/Layout"
import { graphql, useStaticQuery  } from "gatsby"
import Title from "../components/Title"
import Image from "gatsby-image"

const About = () => {
  const{title,stack,info,image} = {
    "id": 1,
    "title": "About Me",
    "info": "Hi, I am passionate about programming which entails problem-solving and critical thinking. I love figuring out problems and learning new technologies. I also love designing three-tier structures, architectural structures, and cloud-based architecture.\nI attended Microverse, an online coding school, to master every aspect of skills a professional programmer should have, from technical skills ( Ruby on Rails, React, Javascript, HTML/CSS) to soft skills (Pair programming, Remote Working, Mentoring), and now I am a Full-Stack Developer available for hire. I also worked with Microverse part-time as a Technical Support Engineer and volunteered as a mentor.\nI am also an experienced Technology Program Facilitator at Kuva Africa, a nonprofit focused on igniting and enhancing leadership entrepreneurship skills and providing diverse platforms and opportunities for young girls in STEAM. Commitment and consistency are some of the values pulling me through my career as a young girl in STEM. My greatest strengths are problem-solving, critical thinking, effective communication, and teamwork.",
    "created_at": "2022-04-13T17:08:10.351Z",
    "updated_at": "2022-04-13T17:08:10.351Z",
    "stack": [
      {
        "id": 1,
        "title": "React & Redux",
      },
      {
        "id": 2,
        "title": "NodeJS",
      },
      {
        "id": 2,
        "title": "Ruby on Rails",
      },
      {
        "id": 2,
        "title": "Javascript",
      },
      {
        "id": 2,
        "title": "HTML/CSS",
      },
      {
        "id": 2,
        "title": "Gatsby & Strapi",
      },
      {
        "id": 2,
        "title": "AWS EC2, s3, iam",
      },
      {
        "id": 2,
        "title": "AWS DYNAMO DB",
      },
      {
        "id": 2,
        "title": "AWS LAMBDA",
      },

    ],
    "image": {
      "id": 1,
      "name": "jane",
      "alternativeText": "",
      "caption": "",
      "width": 512,
      "height": 512,
      "formats": {
        "thumbnail": {
          "hash": "thumbnail_jane_bb830e6208",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.93,
          "path": null,
          "url": "/uploads/thumbnail_jane_bb830e6208.jpeg"
        },
        "small": {
          "hash": "small_jane_bb830e6208",
          "ext": ".jpeg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 24.98,
          "path": null,
          "url": "/uploads/small_jane_bb830e6208.jpeg"
        }
      },
      "hash": "jane_bb830e6208",
      "ext": ".jpeg",
      "mime": "image/jpeg",
      "size": 25.13,
      "url": "/uploads/jane_bb830e6208.jpeg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2022-04-13T17:08:05.217Z",
      "updated_at": "2022-04-13T17:08:05.217Z"
    }
  }
  const query = graphql`
    {
      file(relativePath: {eq: "hero-img.png"}) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `
  const {
    file: {
      childImageSharp: { fluid },
    },
  } = useStaticQuery(query)
  return (
  <Layout>
    <section className="about-page">
      <div className="section-center about-center">
        <Image fluid={fluid} className="about-img"/>
        {/* <Image fluid={image.childImageSharp.fluid} className="about-img" /> */}
        <article className="about-text">
          <Title title={title} />
          <p>{info}</p>
          <div className="about-stack">
            {stack.map((item)=>{
              return <span key={item.id}>{item.title}</span>
            })}

          </div>
        </article>
      </div>
    </section>
  </Layout>
  )
}

// export const query = graphql`
//   {
//     about:allStrapiAbout {
//       nodes {
//         stack {
//           id
//           title
//         }
//         title
//         info
//         image {
//           childImageSharp {
//             fluid {
//               ...GatsbyImageSharpFluid
//             }
//           }
//         }
//       }
//     }
//   }
// `

export default About
